module.exports = __webpack_public_path__ + "img/pencil.682eee42.svg";